export default __webpack_public_path__ + "61794b82cf185789ca5c1420c0fe544d.png";